module.exports = __webpack_public_path__ + "img/baie-mont-saint-michel-small.b932fff7.jpg";